<template>
  <div id="messages">
    <div class="row p-3">
      <div class="col-sm-2">
        <label>Start Date:</label>
        <b-form-input
          type="date"
          v-model="startDate">
        </b-form-input>
      </div>

      <div class="col-sm-2">
        <label>End Date:</label>
        <b-form-input
          type="date"
          v-model="endDate">
        </b-form-input>
      </div>

      <div class="col-sm-4">
        <label>&nbsp;</label>
        <b-form-input
          type="text"
          placeholder="Email, Subject, Content"
          v-model="searchText"
          v-on:keyup.enter.native="getCommunications">
        </b-form-input>
      </div>

      <div class="col-sm-4">
        <label>&nbsp;</label><br />
        <b-button
          class="shadow"
          variant="success"
          @click="getCommunications">
          Search
        </b-button>
      </div>
    </div>

    <!-- Messages Table -->
    <b-table
      striped
      hover
      selectable
      stacked="lg"
      small
      show-empty
      select-mode="single"
      sort-by="created_at"
      :sort-desc="true"
      @row-selected="goToMessage"
      :items="messages"
      :fields="fields"
      empty-text="No Messages to show.">
      <template
        slot="created_at"
        slot-scope="{ item }">
        {{item.display_created_at}}
      </template>

      <template
        slot="text_content"
        slot-scope="{ item }">
        <span v-if="item.text_content">{{item.text_content}}</span>
        <small class="text-italics text-muted" v-if="item.html_content">(click to see email content)</small>
      </template>
    </b-table>
    <!-- / Messages Table -->

    <!-- Create Message Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      @click="$router.push({ name: 'event-communication' })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Compose New Message
    </b-button>
    <!-- / Create Message Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import AppMixin from '../services/app-mixin';
import Formatters from '../services/formatters';
import EventBus from '../services/event-bus';

export default {
  name: 'messages',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      startDate: null,
      endDate: null,
      searchText: '',
      messages: [],
      fields: [
        {
          key: 'sentBy',
          label: 'Sent By',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Sent On',
          sortable: true,
        },
        {
          key: 'to_email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'subject',
          label: 'Subject',
          sortable: true,
        },
        {
          key: 'text_content',
          label: 'Content',
          sortable: true,
        },
        {
          key: 'attachments.length',
          label: 'Attachments',
          class: 'text-sm-right',
          tdClass: 'sort-padding-diff',
          sortable: true,
          formatter: value => (value ? Formatters.number(value, 0) : ''),
        },
      ],
    };
  },
  computed: {

  },
  methods: {
    goToMessage(selected) {
      const [c] = selected;
      this.$router.push({
        name: 'email-communication',
        params: { communicationID: c.id, type: c.type },
      });
    },
    getCommunications() {
      this.showGlobalLoader('Loading messages...');
      return DataSvc.getCommunications({
        organization_id: this.loggedInUser.actingOrg.id,
        start_date: this.startDate,
        end_date: this.endDate,
        search_text: this.searchText
      })
        .then((messages) => {
          this.messages = _.map(messages, (m) => {
            m.sentBy = m.automated ? 'Automated' : (m.sending_user || {}).full_name;
            return m;
          });
        })
        .finally(this.hideGlobalLoader);
    },
  },
  created() {
    this.showGlobalLoader('Loading messages...');

    const initCommunications = () => {
      EventBus.$on('acting-org-changed', this.getCommunications);
      return this.getCommunications();
    };

    this.initPromise.then(initCommunications).finally(this.hideGlobalLoader);
  },
  destroyed() {
    EventBus.$off('acting-org-changed', this.getCommunications);
  },
};
</script>

<style lang="scss"></style>
